import { ALERTAS_ROUTE } from '../constants';
import api from './api';

export default {
	findAll(filter) {
		return api.post(ALERTAS_ROUTE.FIND_BY_FILTER, filter);
	},

	findById(id) {
		return api.get(ALERTAS_ROUTE.FIND_BY_ID.replace('{alertaId}', id));
	},

	createAlerta(alerta) {
		return api.post(ALERTAS_ROUTE.CREATE, alerta);
	},

	alterarStatusAlerta(alerta) {
		return api.post(ALERTAS_ROUTE.CHANGE_STATUS, alerta);
	},

	findAllStatusAlerta() {
		return api.get(ALERTAS_ROUTE.FIND_ALL_STATUS);
	},
};
